import "./App.css";
import { Login } from "./component/Login/Login";
import { Home } from "./component/Home/Home";
import { HashRouter, Switch, Route } from "react-router-dom";
import EhrLogin from "./component/EhrLogin/EhrLogin";
import { Calender } from "./component/Calender/Calender";
import People from "./Pages/People/People";
import OgilyHome from "./component/Home/OgliyHome";
import { SignUp } from "./component/SignUp/SignUp";
import { CreateUser } from "./component/CreateUser/CreateUser";
import UserManagement from "./component/SignUp/UserManagement";
import Router from "./Routes";
import MedizenCreative from "./component/NewCreatives/MedizenCreative/MedizenCreative";
import Mycontext from "./store/Mycontext";
import { useState, useContext } from "react";
import Welcome from "./component/Welcome/Welcome";
import { RiH1 } from "react-icons/ri";
import PharmacyManagementSystem from "./Pages/Pmc/Pmc";
import TaskList from "./component/TaskList/TaskList";

function App() {
  return (
    <HashRouter>
      <Switch>
        <Route path="/home" component={Home} />
        <Route path="/partner-home" component={OgilyHome} />
        <Route path="/EHR-login" component={EhrLogin} />
        <Route path="/Welcome" component={Welcome} />
        <Route path="/Calender" exact component={Calender} />
        <Route path="/TaskList" exact component={TaskList} />
        <Route path="/People/:id" component={People} />
        <Route path="/" exact component={Login} />
        <Route path="/SignUp" component={SignUp} />
        <Route path="/CreateUser" component={CreateUser} />
        <Route path="/UserManagement" component={UserManagement} />
        <Route path="/Pmc/:id" component={PharmacyManagementSystem} />
        <Router />
      </Switch>
    </HashRouter>
  );
}

export default App;
